import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Metformin treatment type.
 */
export const MetforminTreatment = new TreatmentType({
  id: '8',
  name: ConsultationTreatmentTypes.Metformin,
  eligibleTreatmentTypes: [{ id: 3067, name: UpsellSlugs.MetforminExtendedRelease }],
  requireHeightAndWeight: true,
});
